import React from 'react';
import { connect } from 'react-redux';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnPublisher,
  columnStatus,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import paging from '@/hooks/paging';
import CollectionDatasetsTable from '../components/CollectionDatasetsTable';
import CollectionDatasetsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionDatasetsPanelContainer';

const buildColumns = (allowMultiSelect, allowStatus) => {
  const columns = [columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnPublisher,
    columnVisibility,
    columnTools];
  if (allowMultiSelect) {
    columns.push(columnMultiSelect);
  }
  if (allowStatus) {
    columns.push(columnStatus);
  }
  return columns;
};

const CollectionDatasetsPanelFull = ({
  allowMultiSelect,
  allowStatus,
  canManage,
  canRead,
  category,
  code,
  currentPage,
  datasets,
  fetchData,
  onCheckBoxClick,
  showAddDataset,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  theme,
  total,
}) => {
  paging.useFetchByCode(fetchData, category, code, readStatus);

  return (
    <CollectionDatasetsPanelContainer
      readErrors={readErrors}
      canRead={canRead}
      className="aridhia-collection-datasets-panel-full"
    >
      <CollectionDatasetsTable
        canManage={canManage}
        category={category}
        code={code}
        columns={buildColumns(allowMultiSelect, allowStatus)}
        currentPage={currentPage}
        datasets={datasets}
        fetchData={fetchData}
        onCheckBoxClick={onCheckBoxClick}
        pageCount={pageCount}
        pageSize={pageSize}
        readErrors={readErrors}
        readStatus={readStatus}
        showAddDataset={showAddDataset}
        theme={theme}
        total={total}
      />
    </CollectionDatasetsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetsPanelFull);
